import React, { useContext, useEffect, useState } from 'react';
import Breadcrums from '../Components/Breadcrums/Breadcrums';
import { ClipLoader } from 'react-spinners';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import { useParams } from 'react-router-dom';
import { ShopContext } from '../Context/ShopContext';
import { generateSlug } from '../Pages/utils';

const useCSSVariable = (variableName) => {
  const [value, setValue] = useState(() =>
    getComputedStyle(document.documentElement).getPropertyValue(variableName).trim()
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const newValue = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
      setValue(newValue);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    return () => observer.disconnect();
  }, [variableName]);

  return value;
};

const Product = () => {
  const primaryColor = useCSSVariable('--primary');

  const { products } = useContext(ShopContext);
  const { productId } = useParams();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setLoading(true);

    if (!products || products.length === 0) {
      setProduct(null);
      setLoading(true);
      return;
    }

    const found = products.find((e) => generateSlug(e.name) === productId);

    if (!found) {
      console.warn('Produto não encontrado para slug:', productId);
    }

    setProduct(found || null);
    setLoading(false);
  }, [products, productId]);

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <ClipLoader color={primaryColor} size={50} />
        <p>Carregando Exame...</p>
      </div>
    );
  }

  if (!product) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Exame não encontrado</h2>
        <p>O exame que você procura não está disponível.</p>
      </div>
    );
  }

  return (
    <div>
      <Breadcrums product={product} />
      <ProductDisplay product={product} />
    </div>
  );
};

export default Product;
